import Register from "../../components/user/Register";
export default {
  components: {
    Register: Register
  },
  created: function created() {},
  methods: {}
};